// Customizer const
export const TOGGLE_COLLAPSED_NAV = "TOGGLE_COLLAPSE_MENU";
export const WINDOW_WIDTH = "WINDOW-WIDTH";
export const SWITCH_LANGUAGE = "SWITCH-LANGUAGE";

//Contact Module const
export const FETCH_START = "fetch_start";
export const FETCH_SUCCESS = "fetch_success";
export const FETCH_ERROR = "fetch_error";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const HIDE_MESSAGE = "HIDE_MESSAGE";
export const ON_SHOW_LOADER = "ON_SHOW_LOADER";
export const ON_HIDE_LOADER = "ON_HIDE_LOADER";

//Auth const
export const SIGNUP_USER = "SIGNUP_USER";
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const SIGNIN_USER = "SIGNIN_USER";
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNOUT_USER = "SIGNOUT_USER";
export const SIGNOUT_USER_SUCCESS = "SIGNOUT_USER_SUCCESS";
export const INIT_URL = "INIT_URL";

// User const
export const REQUEST_USER_DETAILS = "REQUEST_USER_DETAILS";
export const SUCCESS_USER_DETAILS = "SUCCESS_USER_DETAILS";
export const REQUEST_ALL_USER_DETAILS = "REQUEST_ALL_USER_DETAILS";
export const SUCCESS_ALL_USER_DETAILS = "SUCCESS_ALL_USER_DETAILS";
export const REQUEST_USER_REMOVE = "REQUEST_USER_REMOVE";
export const SUCCESS_USER_REMOVE = "SUCCESS_USER_REMOVE";
export const REQUEST_USER_EDIT = "REQUEST_USER_EDIT";
export const SUCCESS_USER_EDIT = "SUCCESS_USER_EDIT";
export const REQUEST_USER_ADD = "REQUEST_USER_ADD";
export const SUCCESS_USER_ADD = "SUCCESS_USER_ADD";
export const REQUEST_USER_BYID = "REQUEST_USER_BYID";
export const SUCCESS_USER_BYID = "SUCCESS_USER_BYID";

// Attendance const
export const REQUEST_ATTENDANCE_GET = "REQUEST_ATTENDANCE_GET";
export const SUCCESS_ATTENDANCE_GET = "SUCCESS_ATTENDANCE_GET";
export const REQUEST_ATTENDANCE_ADD = "REQUEST_ATTENDANCE_ADD";
export const SUCCESS_ATTENDANCE_ADD = "SUCCESS_ATTENDANCE_ADD";
